import { render, staticRenderFns } from "./CategoryGachaItem.vue?vue&type=template&id=fe454056&scoped=true&"
import script from "./CategoryGachaItem.vue?vue&type=script&lang=js&"
export * from "./CategoryGachaItem.vue?vue&type=script&lang=js&"
import style0 from "./CategoryGachaItem.vue?vue&type=style&index=0&id=fe454056&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe454056",
  null
  
)

export default component.exports